import { render, staticRenderFns } from "./MileageForm.vue?vue&type=template&id=4063d54f&"
import script from "./MileageForm.vue?vue&type=script&lang=js&"
export * from "./MileageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports